// src/components/Eventos/EventsHeats/components/PhotofinishModal.jsx
import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Box, Typography, 
  IconButton, Button, CircularProgress, useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const PhotofinishModal = ({ 
  photofinishModal, 
  closePhotofinishModal, 
  eventName 
}) => {
  const theme = useTheme();

  return (
    <Dialog 
      open={photofinishModal.open} 
      onClose={closePhotofinishModal} 
      maxWidth="lg" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxHeight: 'none'
        }
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        px: 3, 
        py: 2,
        borderBottom: `1px solid ${theme.palette.divider}`
      }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Fotofinish – {eventName} Heat {photofinishModal.heatNumber}
        </Typography>
        <IconButton 
          onClick={closePhotofinishModal}
          sx={{ 
            '&:hover': { 
              backgroundColor: theme.palette.action.hover 
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      
      <DialogContent sx={{ 
        p: 3,
        display: 'flex', 
        flexDirection: 'column',
        gap: 2,
        minHeight: 200
      }}>
        {photofinishModal.loading ? (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            minHeight: 200
          }}>
            <CircularProgress size={40} />
            <Typography sx={{ ml: 2 }}>
              Cargando imágenes...
            </Typography>
          </Box>
        ) : photofinishModal.images.length === 0 ? (
          <Box sx={{ 
            textAlign: 'center', 
            py: 4,
            color: theme.palette.text.secondary
          }}>
            <CameraAltIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
            <Typography variant="h6" gutterBottom>
              No hay imágenes de fotofinish disponibles
            </Typography>
            <Typography variant="body2">
              Las imágenes aparecerán aquí cuando estén disponibles
            </Typography>
          </Box>
        ) : (
          <Box sx={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: 2,
            width: '100%'
          }}>
            {photofinishModal.images.map((img, i) => (
              <Box key={i} sx={{ position: 'relative' }}>
                <Box
                  component="img"
                  src={img}
                  alt={`Fotofinish ${i + 1}`}
                  sx={{ 
                    width: '100%',
                    height: 'auto',
                    borderRadius: 1,
                    boxShadow: theme.shadows[2],
                    transition: 'transform 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      boxShadow: theme.shadows[4]
                    }
                  }}
                />
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button 
          onClick={closePhotofinishModal} 
          variant="contained"
          sx={{ minWidth: 100 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhotofinishModal;